import React from 'react';
import { PageHeaderStyled } from './ui.styles';

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <PageHeaderStyled>
      <div className="text-box">
        <h1>{title}</h1>
        {subtitle ? <p className="subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="actions">{actions}</div> : null}
    </PageHeaderStyled>
  );
}
